import styled from 'styled-components'

export const HeaderStyle = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 180px;
  background-color: ${({ theme }) => {
    return theme.colors.darkPrimary
  }};

  div {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1010px;
    padding: 10px;
  }

  img {
    height: 150px;
  }

  @media screen and (max-width: 720px) {
    height: 140px;

    img {
      height: 100px;
    }
  }

  @media screen and (max-width: 480px) {
    height: 100px;

    img {
      height: 60px;
    }
  }
`
